import { render, staticRenderFns } from "./EventsTemplates.vue?vue&type=template&id=48ac8974&scoped=true&"
import script from "./EventsTemplates.vue?vue&type=script&lang=ts&"
export * from "./EventsTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac8974",
  null
  
)

export default component.exports